import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { PublicState as PublicStateList } from 'utils/constant';
import { platformSoundList } from 'apis/operation/platformSoundApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import SelectSearch from 'components/search/SelectSearch';
import SearchInput from 'components/search/SearchInput';
import RegisterButton from 'components/button/RegisterButton';
import MainTable from 'components/table/MainTable';
import CapsuleButton from 'components/button/CapsuleButton';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import PublicState from 'components/etc/PublicState';
import PlatformSoundRegisterModal from './PlatformSoundRegisterModal';
import PlatformSoundUpdateModal from './PlatformSoundUpdateModal';
import PlatformSoundZipModal from './PlatformSoundZipModal';

// ! TODO : 현재는 1개만 필요. api 추가되면 삭제 후 적용 예정
//(22.05.12  sjy.기존 어드민에서 참고함)
const soundTypeList = [
  {
    key: 0,
    value: 'se',
    text: '효과음',
  },
];

/**
 *
 * @returns {플랫폼 사운드 목록}
 */
const PlatformSoundListPage = () => {
  const publicState = PublicStateList();
  const [cookies] = useCookies();
  const [searchData, setSearchData] = useState();
  const [visible, setVisible] = useState({
    zip: false,
    register: false,
    update: false,
  });
  const [selectSoundType, setSelectSoundType] = useState('se');
  const [datas, setDatas] = useState();
  const [selectData, setSelectData] = useState();

  /// modal show
  const handleOpen = (record) => (e) => {
    setSelectData(record);
    setVisible({ ...visible, [e.target.name]: true });
  };

  /// 삭제하기
  const handleDelete = (record) => () => {
    console.log(record);
  };
  const fetchData = async () => {
    const res = await platformSoundList();
    setDatas(res);
  };

  const columnsOrigin = [
    {
      title: '사운드 ID',
      dataIndex: 'sound_id',
      key: 'sound_id',
    },
    {
      title: '사운드명',
      dataIndex: 'sound_name',
    },
    {
      title: '공개 여부',
      dataIndex: 'is_public',
      render: (text) => <PublicState value={text} />,
      filters: publicState,
      onFilter: (value, record) => record?.is_public === value,
    },
    {
      title: '게임 내 볼륨',
      dataIndex: 'game_volume',
    },
    {
      title: '사운드',
      dataIndex: 'sound_url',
      render: (text, record) => <audio controls src={record.sound_url} />,
    },
    {
      title: '동작',
      render: (t, record) => {
        return (
          <div>
            <CapsuleButton
              name='update'
              onClick={handleOpen(record)}
              disabled={JSON.parse(cookies?.managementAuth)}
            >
              수정
            </CapsuleButton>
            <DeletePopConfirm
              title='해당 사운드를 삭제하시겠습니까?'
              onConfirm={handleDelete(record)}
              disabled={JSON.parse(cookies?.managementAuth)}
            />
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <>
      <DefaultLayout>
        <TableToolbar>
          <div style={{ display: 'flex' }}>
            <SelectSearch
              style={{ marginRight: '1rem' }}
              optionList={soundTypeList}
              value={selectSoundType}
            />
            <SearchInput
              placeholder='사운드명을 입력하세요'
              setSearchData={setSearchData}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <RegisterButton
              name='register'
              onClick={handleOpen()}
              disabled={JSON.parse(cookies?.managementAuth)}
            >
              사운드 등록
            </RegisterButton>
            <RegisterButton
              name='zip'
              onClick={handleOpen()}
              disabled={JSON.parse(cookies?.managementAuth)}
            >
              한 번에 올리기
            </RegisterButton>
          </div>
        </TableToolbar>
        <MainTable
          columns={columnsOrigin}
          dataSource={
            searchData
              ? datas?.filter((v) => v.sound_name.indexOf(searchData) !== -1)
              : datas
          }
        />
      </DefaultLayout>
      {/* 등록 */}
      <PlatformSoundRegisterModal
        visible={visible.register}
        setVisible={setVisible}
        fetchData={fetchData}
        optionList={soundTypeList}
        selectSoundType={selectSoundType}
        setSelectSoundType={setSelectSoundType}
      />
      {/* zip 파일 */}
      <PlatformSoundZipModal
        visible={visible.zip}
        setVisible={setVisible}
        fetchData={fetchData}
        optionList={soundTypeList}
        selectSoundType={selectSoundType}
        setSelectSoundType={setSelectSoundType}
      />
      {/* 수정 */}
      <PlatformSoundUpdateModal
        record={selectData}
        visible={visible.update}
        setVisible={setVisible}
        fetchData={fetchData}
        optionList={soundTypeList}
        selectSoundType={selectSoundType}
        setSelectSoundType={setSelectSoundType}
      />
    </>
  );
};

export default PlatformSoundListPage;
